export const SET_TIMESHEETSTATI = "setTimesheetStati";
export const SET_PROJEKTE = "setProjekte";
export const SET_KUNDEN = "setKunden";
export const SET_INTERNECODES = "setInterneCodes";
export const SET_PROJEKTSTATI = "setProjektStati";
